module["exports"] = ["Norge"];